import { render, staticRenderFns } from "./LandingIntro.vue?vue&type=template&id=65c146ba&scoped=true"
import script from "./LandingIntro.vue?vue&type=script&lang=js"
export * from "./LandingIntro.vue?vue&type=script&lang=js"
import style0 from "./LandingIntro.vue?vue&type=style&index=0&id=65c146ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c146ba",
  null
  
)

export default component.exports